module.exports = __webpack_public_path__ + "media/images/svgs/back_arrow_icon-c0cede3a55c7370835e2dbfea9888d6b.svg";